module.exports = {
  language: {
    name: 'English'
  },
  home: {
    name: 'QI GAO LE',
    newproduct: 'NEW PRODUCT',
    relationproduct: 'RELATION PRODUCT'
  },
  header: {
    lang: 'QI GAO LE',
    logo: 'QI GAO LE',
    home: 'HOME',
    product: 'PRODUCT',
    video: 'VIDEO',
    news: 'NEWS',
    about: 'ABOUT',
    search: 'search',
    searchsearch: "search",
    langageimg: 'cn.png'
  },
  footer: {
    lang: '中文版',
    home: 'HOME',
    product: 'PRODUCT',
    video: 'VIDEO',
    news: 'NEWS',
    about: 'ABOUT',
    concact: '',
    power: '2022-2030 All Right Reserved ',
    address: 'QI GAO LE TOYS, Shantou, Guangdong Province',
    conputy: 'QIGAOLETOYS | Visitor Count:'
  }
}



// WEBPACK FOOTER //
// ./src/language/en.js